import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Entry, TimelineEntry, formatDate} from './Shared';

export const ExtraWorkEntryAddedTimelineEntry = ({entry}) => {
    const {t} = useTranslation();

    return (
        <TimelineEntry entry={entry} status="new" icon="work">
            <Entry.Title>
                <Trans
                    i18nKey="warehousing.timeline.ExtraWorkEntryAdded.title"
                    values={{extraWorkItem: entry.extraWorkItemDescription}}
                />
            </Entry.Title>
            <Entry.Extra>
                <li>
                    <strong>{t('customer.ExtraWorkEntries.Date')}</strong>: {formatDate(entry.timestamp)}
                </li>
                <li>
                    <strong>{t('customer.ExtraWorkEntries.Quantity')}</strong>: {entry.quantity}
                </li>
                {entry.remark && (
                    <li>
                        <strong>{t('customer.ExtraWorkEntries.Remark')}</strong>: {entry.remark}
                    </li>
                )}
            </Entry.Extra>
        </TimelineEntry>
    );
};
